import { render, staticRenderFns } from "./ObiSessionLimit.vue?vue&type=template&id=e69fd616&scoped=true&"
import script from "./ObiSessionLimit.vue?vue&type=script&lang=js&"
export * from "./ObiSessionLimit.vue?vue&type=script&lang=js&"
import style0 from "./ObiSessionLimit.vue?vue&type=style&index=0&id=e69fd616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69fd616",
  null
  
)

export default component.exports